var exports = {
  "qS": "MentionBadge.module__badge___TUtkQm",
  "ZN": "MentionBadge.module__badgeSmall___TUtkQm",
  "N1": "MentionBadge.module__badgeMedium___TUtkQm",
  "x5": "MentionBadge.module__animatedWrapper___TUtkQm",
};

module.exports = exports;
